import { toast } from "../components/Toast"

export const VALID_FILETYPES = ["image/jpg", "image/jpeg", "image/png", "video/mp4", "video/mov", "video/quicktime"]
export const MAX_FILE_SIZE = 1000000000

const isFileTypeValid = (file: File, withError: boolean = true) => {
  const isValid = VALID_FILETYPES.includes(file.type)
  if (!isValid && withError) {
    toast.error(`Invalid file type: ${file.type.split("/")[1].toUpperCase()}`)
  }
  return isValid
}

const isFileSizeValid = (file: File, withError: boolean = true) => {
  const isValid = file.size < MAX_FILE_SIZE
  if (!isValid && withError) {
    toast.error("File size can not exceed 1GB")
  }
  return isValid
}

export const isFileValid = ({ file, withError = true }: { file: File; withError?: boolean }) => {
  return isFileTypeValid(file, withError) && isFileSizeValid(file, withError)
}
